<template>
    <div class="modal-backdrop">
        <div class="modal-content">
            <h2>Clock In</h2>
            <p>Please select your work location</p>
            <form @submit.prevent="submitClockIn">
                <div class="radio-group">
                    <input type="radio" id="office" class="radioLabel" v-model="workLocation" value="Office" required />
                    <label for="office">Office</label>
                    <input type="radio" id="home" class="radioLabel" v-model="workLocation" value="Home" required />
                    <label for="home">Home</label>
                    <input type="radio" id="Business" class="radioLabel" v-model="workLocation" value="Business Trip" required />
                    <label for="Business">Business Trip</label>
                </div>
                
                <button type="button" @click="$emit('close')">Cancel</button>
                <button type="submit">Clock In</button>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["clock-in", "close"]);

const workLocation = ref(null);

async function submitClockIn() {
  emit("clock-in", workLocation.value);
}
</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
    .modal-content {
        background: white;
        padding: 2rem;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        width: 300px;
        text-align: center;
        p{
            margin-top: 2rem;
            font-size: 14px;
            color: var(--blue);
        }
        & h2 {
            margin-top: 0;
            color: var(--blue);
        }
    }

    .radio-group {
        margin: 2rem 0;
        label {
            padding: 0.5rem 1.5rem;
            margin: 0.5rem auto;
            color: var(--blue);
            border: 1px dashed var(--midLightBlue);
            border-radius: 100px;
            transition: 0.3s;
            display: block;
        }

        input[type="radio"] {
            display: none;
            &:checked + label {
                border: 1px solid var(--blue);
                background: var(--blue);
                color: white;

            }
        }
    }

    button {
        background: var(--grad90);
        color: white;
        border: none;
        width: 60%;
        max-width: 300px;
        padding: 1rem;
        border-radius: 5px;
        cursor: pointer;
        margin: 5px;
        &[type="button"] {
            width: 30%;
            background: none;
            color: var(--blue);
            border: 1px solid var(--blue);
        }
    }
</style>
